module.exports = __webpack_public_path__ + "static/media/pale-welcome.4456fc9c.svg";